module.exports = __webpack_public_path__ + "static/media/bg-image-29.269c71f6.jpg";